import log from 'loglevel';
import * as Sentry from '@sentry/browser';

const onError = (err: any) => {
  Sentry.captureException(err);
  log.error(err);
};

export default onError;
